class SingletonOpenManager {
  constructor() {
    this.id = null;
    this.listeners = new Set();
  }

  open(id) {
    if (this.id && this.id !== id) {
      this.notifyListeners(this.id, false);
    }

    this.id = id;
    this.notifyListeners(id, true);
  }

  close(id) {
    if (this.id === id) {
      this.id = null;
      this.notifyListeners(id, false);
    }
  }

  isOpen(id) {
    return this.id === id;
  }

  addListener(callback) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  notifyListeners(id, isOpen) {
    this.listeners.forEach((callback) => callback(id, isOpen));
  }
}

export default SingletonOpenManager;
